import { Row, Col, Avatar } from "antd";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { useEffect, useState } from "react";
import { useStores } from "../../store";
import { persistJwtToken, _i, __ } from "../../utils";
import { LOCAL_STORAGE_JWT_TOKEN_NAME } from ".";
const AccountHeader = observer(() => {
  const [loadGravatar, setLoadGravatar] = useState(false);
  const {
    accountStore: {
      session
    }
  } = useStores();
  const {
    user: {
      firstName,
      email,
      emailMd5
    }
  } = session;
  const handleLogout = useCallback(async e => {
    e.preventDefault();
    try {
      await session.logout();
    } catch (e) {
      // Silence is golden.
    } finally {
      persistJwtToken(LOCAL_STORAGE_JWT_TOKEN_NAME, undefined);
      window.location.reload();
    }
  }, [session]);

  // Check if gravatar may be loaded
  useEffect(() => {
    const {
      consentApi
    } = window;
    if (consentApi) {
      consentApi.unblock("gravatar.com/avatar").then(() => setLoadGravatar(true));
    } else {
      setLoadGravatar(true);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    align: "middle",
    gutter: 20
  }, loadGravatar && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Avatar, {
    src: `https://www.gravatar.com/avatar/${emailMd5}`,
    size: 60,
    shape: "circle"
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 25,
      fontWeight: "bold"
    }
  }, __("Hey %s, nice to see you!", firstName)), /*#__PURE__*/React.createElement("br", null), _i(__("You are currently logged in with {{strong}}%s{{/strong}}", email), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  }), "\xA0\u2022\xA0", /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: handleLogout
  }, __("Logout")))));
});
export { AccountHeader };